import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import categoriaService from '../services/getCategoria';

const initialState = {
  error: false,
  success: false,
  loading: false,
  categoriasCompra: [],
};

export const getCategoria = createAsyncThunk('categoria/getCategoria', async (_, thunkAPI) => {
  const response = await categoriaService.getCategoriaCompra();
  return response;
});

export const categoriaSlice = createSlice({
  name: 'categoria',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.categoriasCompra = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoria.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCategoria.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.categoriasCompra = action.payload;
      })
      .addCase(getCategoria.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.user = null;
      });
  },
});

export const { reset } = categoriaSlice.actions;
export default categoriaSlice.reducer;
